/**
 * WorkOS Portals (and their "intents")
 *
 * See https://workos.com/docs/reference/admin-portal/portal-link/generate
 *
 * These are a set of static routes we maintain which then dynamically
 * create routes to the WorkOS admin portal based on the intent.
 *
 * As of Dec 2024 there are six intents.
 */
const workOsPortalRoutes = {
  auditLogs: '/auth/audit-logs/portal',
  certificateRenewal: '/auth/certificate-renewal/portal',
  dSync: '/auth/directory-sync/portal',
  domainVerification: '/auth/domain-verification/portal',
  logStreams: '/auth/log-streams/portal',
  sso: '/auth/sso/portal',
} as const;

export default workOsPortalRoutes;
